module.exports = __webpack_public_path__ + "img/Logo-Up-Romania.232a1e07.svg";